import React, {useState} from "react";
import {GridTable, ResultsPager} from "../../../Components/Grid";
import {isArrayNullOrEmpty} from "../../../Utilities/Types/arrayUtilities";
import {OrderManagementRow} from "./OrderManagementRow";
import {DialogBox} from "../../../Components/Dialog/DialogBox";
import {OrderEditFormView} from "./OrderEditFormView";
import {Order, OrderSearchCriteria} from "./orderManagement.types";

interface OrderManagementViewProps {
    canManageOrders: boolean;
    handleCancelOrder: (orderId: string) => void;
    handleSaveUpdatedOrder: (order: Order) => void;
    handleSetOrderSearchCriteria: (criteria: OrderSearchCriteria) => void;
    orderSearchCriteria: OrderSearchCriteria;
    orders: Order[];
    redirect: (path: string) => void;
    totalRecords: number;
}

export const OrderManagementView = ({
                                        canManageOrders,
                                        handleCancelOrder,
                                        handleSaveUpdatedOrder,
                                        handleSetOrderSearchCriteria,
                                        orderSearchCriteria,
                                        orders,
                                        redirect,
                                        totalRecords
                                    }: OrderManagementViewProps) => {

    const [orderForDialog, setOrderForDialog] = useState<Order | null>(null);
    const [isOrderEditDialogOpen, setIsOrderEditDialogOpen] = useState(false);

    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        let criteria = {...orderSearchCriteria};
        const columnId = (event.target as HTMLElement).dataset.id;
        if (columnId) criteria.UpdateSorting(columnId);
        handleSetOrderSearchCriteria(criteria);
    };

    const handleFirstClick = () => {
        let criteria = {...orderSearchCriteria};
        criteria.First();
        handleSetOrderSearchCriteria(criteria);
    };
    const handlePreviousClick = () => {
        let criteria = {...orderSearchCriteria};
        criteria.Previous();
        handleSetOrderSearchCriteria(criteria);
    };

    const handleNextClick = () => {
        let criteria = {...orderSearchCriteria};
        criteria.Next();
        handleSetOrderSearchCriteria(criteria);
    };
    const handleLastClick = () => {
        let criteria = {...orderSearchCriteria};
        criteria.Last(totalRecords);
        handleSetOrderSearchCriteria(criteria);
    };
    const pager = (isSecondaryPager: boolean) =>
        <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={orderSearchCriteria.recordsPerPage}
            currentPage={orderSearchCriteria.page}
            disabled={false}
        />;

    const handleOpenEditDialog = (event: React.MouseEvent<HTMLElement>, order: Order) => {
        event.preventDefault();
        setOrderForDialog({...order});
        setIsOrderEditDialogOpen(true);
    };

    const handleCloseEditDialog = () => {
        setIsOrderEditDialogOpen(false);
        setOrderForDialog(null);
    };

    const handleSaveOrder = () => {
        if (orderForDialog) {
            handleSaveUpdatedOrder(orderForDialog);
            handleCloseEditDialog();
        }
    };

    const noResults = isArrayNullOrEmpty(orders);
    const canOpenOrderEditDialog = canManageOrders && isOrderEditDialogOpen && orderForDialog;

    return <>
        {pager(false)}
        <GridTable className="searchResults">
            <thead>
            <tr>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateCreatedUtc">Order Date</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="needFrom">Need From</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="accessNumber">Access#</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="itemName">Item</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="districtName">District</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="shelfLocation">Shelf Location</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="studentName">Student</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="orderStatus">Order Status</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateOrderSentToVendor">Order Sent</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateOrderReceivedFromVendor">Order Received</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="poNumber">PO#</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="notes">Notes</th>
                <th scope={"col"} className={"align-center"}>
                    Actions
                </th>
            </tr>
            </thead>
            <tbody>
            {
                !noResults &&
                orders.map((order) => {
                        return (<OrderManagementRow
                            key={order.orderId}
                            canManageOrders={canManageOrders}
                            handleCancelOrder={handleCancelOrder}
                            handleOpenEditDialog={handleOpenEditDialog}
                            redirect={redirect}
                            order={order}
                        />);
                    }
                )
            }
            {
                noResults &&
                <tr data-testid={`no-order-row`}>
                    <td colSpan={13} className={`text-center`}>No results found.</td>
                </tr>
            }
            </tbody>
        </GridTable>
        {pager(true)}
        {
            canOpenOrderEditDialog &&
            <DialogBox
                handleCancel={handleCloseEditDialog}
                handleSave={handleSaveOrder}
                openDialog={isOrderEditDialogOpen}
                title={`Edit Order: ${orderForDialog.itemName}`}>
                <OrderEditFormView
                    orderForDialog={orderForDialog}
                    setOrderForDialog={setOrderForDialog}/>
            </DialogBox>
        }
    </>;
}

